import { render, staticRenderFns } from "./addmodel.vue?vue&type=template&id=41ec3d52"
import script from "./addmodel.vue?vue&type=script&lang=js"
export * from "./addmodel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports